import {Avatar, ColorSchemeType, Flag} from 'platform/components';
import {Box, HStack, Text, VStack} from 'platform/foundation';

import {ReactNode} from 'react';

import {isNotNil} from 'ramda';

import {TestIdProps, suffixTestId} from 'shared/web';

interface RecordAuditTeamMemberProps extends TestIdProps {
  name: string;
  roleLabel: string;
  roleColorScheme: ColorSchemeType;
  /** Top-right control: edit dropdown for the auditor, delete button for participants. */
  action?: ReactNode;
}

export function RecordAuditTeamMember(props: RecordAuditTeamMemberProps) {
  return (
    <Box
      position="relative"
      padding={3}
      border="1px solid"
      borderColor="palettes.neutral.40.100"
      borderRadius="small"
      data-testid={props['data-testid']}
    >
      <HStack spacing={3} align="center">
        <Avatar name={props.name} size="default" />
        <VStack spacing={1}>
          <Flag label={props.roleLabel} colorScheme={props.roleColorScheme} isSubtle />
          <Text size="small" alternative color="link" data-testid={suffixTestId('name', props)}>
            {props.name}
          </Text>
        </VStack>
      </HStack>
      {isNotNil(props.action) ? (
        <Box position="absolute" top={2} right={2}>
          {props.action}
        </Box>
      ) : null}
    </Box>
  );
}
